export default (config, getState) => {
  const state = getState();
  const token = state?.oidc?.user?.access_token;

  if (token) {
    const configUpdate = { ...config };
    configUpdate.headers = { ...(configUpdate.headers || {}) };
    // Ensure Authorization header is set in a consistent manner
    configUpdate.headers.Authorization = `Bearer ${token}`;
    return configUpdate;
  }

  return config;
};

// export default (config, getState) => {
//   const state = getState();
//   const token = state.oidc?.user?.access_token || 
//                 sessionStorage.getItem('oidc.user:auth_token') || 
//                 JSON.parse(sessionStorage.getItem('oidc.user:' + window.__ENV.REACT_APP_OAUTH_AUTHORITY + ':' + window.__ENV.REACT_APP_OAUTH_CLIENT_ID))?.access_token;

//   if (token) {
//     // eslint-disable-next-line no-param-reassign
//     config.headers.Authorization = `Bearer ${token}`;
//   }

//   return config;
// };
